/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tense_Such_Hare_ConquerInputs */

const fr_tense_such_hare_conquer = /** @type {(inputs: Tense_Such_Hare_ConquerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques`)
};

/**

* @param {Tense_Such_Hare_ConquerInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tense_such_hare_conquer = /** @type {((inputs?: Tense_Such_Hare_ConquerInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tense_Such_Hare_ConquerInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tense_such_hare_conquer(inputs)
});